import DataHolder, {DataHolderImpl} from '@mmt/legacy-commons/Common/navigation/DataHolder';
import { BusSharedModule } from './types';
export * from './types';

const BusSharedModuleHolder: DataHolder<BusSharedModule> = new DataHolderImpl<BusSharedModule>();

export default BusSharedModuleHolder;
